import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Link, SmartInput } from '@beef/legacy-ui-kit';

import { useCaptcha } from './hooks/useCaptcha';

import styles from './Captcha.pcss';
import { CaptchaPopupProps, CaptchaTextsType } from './types';

const cx = classNames.bind(styles);

export const Captcha: FC<CaptchaPopupProps & CaptchaTextsType> = ({
  status,
  msg,
  errorMsg,
  captchaPic,
  onMount,
  onChange,
  refreshCaptcha,
  fetchCaptcha,
  handleSubmit,
}) => {
  const { captcha, inputError, inputStatus, handleChange, handleRefreshCaptcha, onFocus, onBlur } =
    useCaptcha({
      refreshCaptcha,
      onMount,
      onChange,
      fetchCaptcha,
      errorMsg,
      status,
    });

  const handleCaptcha = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };
  return (
    <form className={cx('captcha')} onSubmit={handleCaptcha}>
      <span>{msg?.title}</span>
      <SmartInput
        captcha={captchaPic}
        className={cx('captchaInput')}
        inputId="captchaId"
        mask="_____"
        msg={inputError}
        name="captchaInput"
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        status={inputStatus}
        value={captcha}
      />
      <div className={cx('reset')}>
        <Link onClick={handleRefreshCaptcha}>{msg?.reloadText}</Link>
      </div>
    </form>
  );
};
